module.exports = __webpack_public_path__ + "static/media/video.7d7a15b2.svg";